// @flow
import React from 'react';
import styled, { css, keyframes } from 'styled-components';

const pulse = keyframes`
  0%,
  60%,
  100% {
    opacity: 1;
    transform: scale(1);
  }

  30% {
    opacity: 0.1;
    transform: scale(0.01);
  }
`;

const pulseRule = css`
  ${pulse} 1s ease infinite;
`;

const getColor = (theme, color) => (color ? theme.colors[color] || color : theme.mainColor);

const Dot = styled.div`
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 100%;
  margin: 2px;
  animation: ${pulseRule};
`;

const SpinnerStyled = styled.div`
  display: inline-block;
  position: relative;
  width: ${({ width }) => width};
  height: 18px;

  ${/* sc-sel */ Dot} {
    background-color: ${({ color, theme }) => getColor(theme, color)};
  }

  & > div:nth-child(1) {
    animation-delay: -200ms;
  }

  & > div:nth-child(2) {
    animation-delay: -100ms;
  }

  & > div:nth-child(3) {
    animation-delay: 0ms;
  }
`;

type Props = {
  color?: string,
  width?: string
};

export const Spinner = ({ color, width = '54px' }: Props) => (
  <SpinnerStyled color={color} width={width}>
    <Dot />
    <Dot />
    <Dot />
  </SpinnerStyled>
);
